import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { useInfiniteLocationSearchQuery } from '@/api/accommodation/hooks'
import { HomeSearchFilters } from './HomeSearchFilters'
import Search from '@/features/accommodation/search/components/search'
import Divider from '@/components/divider'
import Navbar from '@/components/navbar'
import Footer from '@/components/footer'
import { Typography } from '@/components/ui/typography'
import { useIsMobile } from '@/hooks/useIsMobile'
import { HowItWorks } from './HowItWorks'
import { WhyTravelWithUs } from './WhyTravelWithUs'
import { MobileSearchSummary } from '@/features/accommodation/search/components/MobileSearchSummary'
import { StayTypeCards } from './StayTypeCards'
import { trackHomeExploreClicked } from '@/lib/track'
import heroBg from '@/assets/hero.webp'

const HOME_PAGE_SIZE = 6
const MOBILE_PAGE_SIZE = 3

export function HomeContent() {
  const isMobile = useIsMobile()

  const accommodationSearchQuery = useInfiniteLocationSearchQuery(
    {
      beds: 2,
      cribs: 0,
      region: 'all',
      adult: false,
      pets: false,
      take: HOME_PAGE_SIZE,
      order: 'start',
      direction: 'asc',
    },
    HOME_PAGE_SIZE,
  )

  return (
    <div>
      <div className="relative">
        {/* Real <img> (not a CSS background) so it is the LCP element and the
            preload scanner can prioritize it. `heroBg` is Vite's content-hashed
            URL — swapping src/assets/hero.webp rebuilds a new hash, so the
            immutable cache is busted automatically (no manual rename). The
            prerender step preloads this same hashed URL on the homepage (read
            from the build manifest — see generate-prerendered-heads.ts). */}
        <img
          src={heroBg}
          alt=""
          width={1440}
          height={788}
          fetchPriority="high"
          decoding="async"
          className="absolute top-0 right-0 bottom-0 left-0 -z-10 h-full w-full object-cover object-center"
        />
        <div className="absolute top-0 right-0 bottom-0 left-0 -z-10 bg-black/15 bg-cover bg-center bg-no-repeat" />

        <Navbar isLight={true} />

        <div className="container grid grid-cols-1 gap-12 bg-black/0 py-8 font-normal text-white md:grid-cols-2 lg:py-32 lg:pt-24">
          <div className="space-y-8">
            <Typography variant="h1">Last-minute ubytování na výjimečných místech</Typography>
            <p className="max-w-[80%] text-sm text-white lg:max-w-full lg:text-lg">
              Od roubenek a chalup až po penziony a hotely. Vaše vysněné místo má na dlouho dopředu obsazeno?
              Nezoufejte, vyberte si z nabídky a my uvolněné místa pohlídáme za vás.
            </p>
            <Button variant="red" asChild className="mb-8">
              <Link to="/ubytovani/hledat" onClick={() => trackHomeExploreClicked()}>
                Prozkoumat nabídky
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {isMobile && (
        <div className="container -mt-8">
          <MobileSearchSummary />
        </div>
      )}

      <div className="container -mt-14 hidden lg:block">
        <HomeSearchFilters className="mb-12" />
      </div>

      <div className="container">
        <Typography variant="h3" className="mt-8 mb-6 lg:mt-0">
          Nabídky ubytování
        </Typography>
        <Search
          queryResult={accommodationSearchQuery}
          pageSize={HOME_PAGE_SIZE}
          maxItems={isMobile ? MOBILE_PAGE_SIZE : undefined}
          linkToSearch
        />

        <Divider size="lg" />
      </div>

      <div className="container">
        <Typography variant="h3" className="mb-6">
          Typ pobytu
        </Typography>
        <StayTypeCards />
        <Divider size="xl" />
      </div>

      <HowItWorks />

      <WhyTravelWithUs />

      <Footer />
    </div>
  )
}
